import { inject, Injectable } from '@angular/core';
import { NOTIFICATION_CONFIG } from '../providers/notification.providers';

@Injectable({
    providedIn: 'root',
})
export class HtmlNotificationService {
    private readonly config = inject(NOTIFICATION_CONFIG);

    open<T>(
        message: string,
        title: string,
        tag?: string,
        data?: T,
        onClick?: (data: T) => void,
    ): void {
        Notification.requestPermission().then((result) => {
            if (result === 'granted') {
                const notificationToast = new Notification(title, {
                    body: message,
                    tag,
                    icon: this.config.htmlNotificationIcon,
                });
                notificationToast.onclick = function () {
                    if (onClick != null && data != null) {
                        onClick(data);
                    }

                    notificationToast.close();
                };
            }
        });
    }
}
